import { createRoot } from 'react-dom/client';
import logo from './brands/runport/logo.png';
import { theme } from './brands/runport/theme';
import { LandingPage } from './main-landing';

createRoot(document.getElementById('root')).render(
  <LandingPage
    brandTheme={theme}
    brandLogo={logo}
    productName="RunPort Desk"
    audienceLabel="大会事務局"
    supportEntityLabel="大会"
    officialInfoLabel="大会サイトやFAQ"
    preview={{
      sender: '田中 花子',
      contacts: [
        { initial: '田', subject: 'ゼッケンはいつ届きますか？' },
        { initial: '鈴', subject: '駐車場について' },
        { initial: '佐', subject: 'コースの変更はありますか？' },
      ],
      draft: 'お問い合わせありがとうございます。ゼッケンは大会の約10日前を目安に、ご登録の住所へ発送いたします。',
      signature: 'RunPortマラソン大会事務局',
    }}
  />
);
